import { useLocation, useNavigate } from 'react-router-dom';
import type { Analyse } from 'r/types';
import { useVerifyAnalysis } from '../../AnalysisManagerTab/mutations';

/**
 * Opens the Play event form for an analysis, verifying it first when needed
 * (same flow as the "Add Play event" button on the analysis card).
 */
export default function useOpenPlayEvent() {
  const navigate = useNavigate();
  const location = useLocation();
  const { mutate: verifyAnalysis, isPending } = useVerifyAnalysis();

  const openPlayEvent = (analysis: Analyse) => {
    const open = () =>
      navigate(`/analyses/${analysis.id}/play-event`, {
        state: { background: location },
      });

    if (analysis.verifiedBy) open();
    else verifyAnalysis(analysis.id, { onSuccess: open });
  };

  return { openPlayEvent, isPending };
}
